import React from "react";
import Box from "@mui/material/Box";
import { Grid, DialogContent, Dialog } from "@material-ui/core";
import CustomReport from "./customReport";
import ModalCloseButton from "../../components/UI/ModalCloseButton";

export default function DownloadReportMain(props) {
    const { open, setOpen } = props;

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            disableEnforceFocus
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            PaperProps={{
                style: {
                    backgroundColor: "#272727",
                    border: "1px solid #505050",
                    color: "#ffffff",
                },
            }}
        >
            <Grid item xs={12} sm={12} md={12}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <ModalCloseButton
                        onClick={handleClose}
                        style={{ position: "static" }}
                    />
                </Box>
            </Grid>
            <DialogContent>
                <CustomReport onClose={handleClose} />
            </DialogContent>
        </Dialog>
    );
}
